module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Stardust.a5bb5fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Stardust.jpg
// module id = 59S8
// module chunks = 0